import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import CalcShell from "../../components/CalcShell";
import CalcField from "../../components/CalcField";
import { formatINR } from "../../utils/format";

const meta = { slug: "fd", emoji: "🏦", title: "FD Calculator", desc: "Project the maturity value of a fixed deposit." };

function FDCalculator() {
  const [principal, setPrincipal] = useState(100000);
  const [rate, setRate] = useState(7);
  const [years, setYears] = useState(5);

  // Quarterly compounding, the Indian FD standard.
  const n = 4;
  const maturity = principal * Math.pow(1 + rate / 100 / n, n * years);
  const interest = maturity - principal;

  return (
    <CalcShell
      meta={meta}
      note={
        <span>
          <strong>Note:</strong> This uses quarterly compounding, the standard for
          most Indian bank FDs. Interest earned is taxable at your income slab.
        </span>
      }
    >
      <Row>
        <Col md={6}>
          <CalcField label="Deposit amount (₹)" value={principal} onChange={setPrincipal} min={1000} max={10000000} step={1000} prefix="₹" />
          <CalcField label="Interest rate (% p.a.)" value={rate} onChange={setRate} min={1} max={12} step={0.1} suffix="%" />
          <CalcField label="Tenure (years)" value={years} onChange={setYears} min={1} max={10} step={1} suffix="yr" />
        </Col>
        <Col md={6}>
          <div className="fi-calc-result mb-3">
            <div>Maturity value</div>
            <div className="big">{formatINR(maturity)}</div>
          </div>
          <Row className="g-3">
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(principal)}</div>
                <small className="text-muted">Invested</small>
              </div>
            </Col>
            <Col xs={6}>
              <div className="fi-stat">
                <div className="num">{formatINR(interest)}</div>
                <small className="text-muted">Interest earned</small>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </CalcShell>
  );
}

export default FDCalculator;
